<template>
  <div class="box">
    <div class="panel-header">
      <div class="panel-title">오늘 인기 공간 상품</div>
    </div>
    <div class="panel-content">
      <div style="margin-top:8px">
      <div class="grid-th" v-if="list && list.length>0">
        <div class="th" v-for="(item, idx) in headers" :key="`th-${idx}`">{{ item }}</div></div>
        <template v-if="list">
          <div v-for="(item,idx) in list" :key="`prod-${item.id}`" class="grid-prod">
         <div class="weight-600">{{ idx + 1 }}</div>
         <div class="flex-align" style="gap:0 20px">
           <img :src="item.img" alt="item.name" class="img-prod">
           <div class="size-12" style="text-align: left">
             <div>{{ item.name }}</div>
             <div>
               <span v-if="item.price.is_discount" class="primary" style="margin-right:4px">
                 <template v-if="item.price.discount_type===0">{{ item.price.discount_rate }}%</template>
                 <template v-if="item.price.discount_type===1">{{ item.price.discount_price|currency }}</template>
               </span>
               <span>{{ item.price.sale_price|currency }}</span>
             </div>
           </div>
         </div>
         <div>{{ item.reviews_count|currencyNum }}</div>
         <div>{{ item.like_count|currencyNum }}</div>
         <div>{{ item.ordered_count|currencyNum }}</div>
       </div>
          <div v-if="list.length===0" class="empty-view">조회할 인기 공간 상품이 없습니다.</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PanelTodayPopular',
    created() {
      this.getData();
    },
    data() {
      return {
        selectedPackage: undefined,
        list: undefined,
        headers: ['상품', '후기', '찜', '전화문의']
      }
    },
    computed: {
    },
    methods: {
      getData() {
        let url = 'user/0/space/product?fields=id,name,price,img,reviews_count,like_count,ordered_count';
        url += '&page_length=5&ordering=-visit';
        this.$axios.get(url).then(res => {
          this.list = res.data.data;
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .panel-title
    color #363636
    font-size 21px
    font-weight 300

  .panel-content
    padding 20px

  .pack-tab-wrapper
    display flex
    align-items center
    gap 8px
  .pack-tab-item
    border-radius 50px
    padding 6px 14px
    border 1px solid #dddddd
    background-color white
    color #363636
    font-size 14px
    line-height 22px
  .selected
    background-color #363636
    border 1px solid #363636
    color white
  .grid-th
    display grid
    grid-template-columns 1fr repeat(3, 100px)
    grid-gap 20px
    border-bottom 1px solid #ddd
    text-align center
  .th
    padding 8px 0
    color #787878
    font-size 12px
  .th:first-child
    text-align left
  .grid-prod
    display grid
    grid-template-columns 20px 1fr repeat(3, 100px)
    grid-gap 20px
    text-align center
    color #363636
    margin-top 16px
    align-items center
    .img-prod
      width 48px
      height 48px
      object-fit cover
      border-radius 8px
  .empty-view
    margin 48px 0 24px 0
    color #787878
    text-align center

  @media(max-width: 1200px)
    .grid-th
      grid-template-columns 1fr repeat(3, 40px)
    .grid-prod
      grid-template-columns 20px 1fr repeat(3, 40px)

</style>
